/* eslint-disable react-hooks/exhaustive-deps */
//import { useEffect } from "react";
import { Grid, Box, Container, Typography, Button, useMediaQuery, useTheme } from "@mui/material";
//import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { signOut } from "aws-amplify/auth";
//import { RootState, useAppDispatch } from "@store/store";
//import { useLazyGetLoanApplicationByIdQuery } from "@api/applications";
import { InactivityHandler } from "@components/InactivityHandler";
import IconSpeed from "@components/Images/IconSpeed";
//import { setLoanStatus } from "@store/slices/registerSlice";

//const SECONDS_TO_FETCH = 10 * 1000;

const WaitingRoomAvalAdicional = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  // const dispatch = useAppDispatch();

  // const application = useSelector((state: RootState) => state.register.application);
  // const [getLoadApplication] = useLazyGetLoanApplicationByIdQuery();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const logOut = async () => {
    await signOut();
    navigate("/login");
  };

  // useEffect(() => {
  //   const intervalFetch = setInterval(async () => {
  //     try {
  //       const response = await getLoadApplication(application.id).unwrap();
  //       const url_actual = response?.status_catalog?.url_actual || "";
  //       const code_actual = response?.status_catalog?.code || "";

  //       if (url_actual && code_actual) {
  //         if (url_actual.includes("/en_revision")) {
  //           dispatch(setLoanStatus(code_actual));
  //           navigate("/producto/creditosimple/en_revision");
  //         }
  //       }
  //     } catch (error) {
  //       console.log("Ha ocurrido un error", error);
  //     }
  //   }, SECONDS_TO_FETCH);

  //   return () => {
  //     intervalFetch && clearInterval(intervalFetch);
  //     document.body.style.backgroundColor = "";
  //   };
  // }, []);

  return (
    <>
      <Grid container sx={{ position: "relative" }} height="90%">
        <InactivityHandler />

        <Grid item xs={12} md={12} mt={1}>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Container sx={{ mb: 2 }}>
              <Typography
                fontSize={"31px"}
                fontWeight={"600"}
                align="center"
                color={theme?.palette?.primary?.dark}
                lineHeight={"39.06px"}
              >
                En espera de Información de Aval Adicional
              </Typography>
            </Container>

            <Box sx={{ mb: 1 }}>
              <Typography
                fontWeight={600}
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.primary?.dark}
                align="center"
                width={isMobileOrTablet ? "280px" : "400px"}
              >
                Estamos en espera de la información del aval adicional para completar tu solicitud.
              </Typography>
            </Box>

            <Box sx={{ mt: 2, mb: 2 }}>
              <IconSpeed fill={theme.palette.primary.dark} />
            </Box>

            <Box sx={{ mt: 3, mb: 1 }}>
              <Typography
                fontWeight={"300"}
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.primary?.dark}
                align="center"
                width={isMobileOrTablet ? "280px" : "400px"}
              >
                ¡Despreocúpate! <br />
                Puedes salir de esta pantalla, tan pronto esté lista tu oferta personalizada podrás consultarla aquí
                mismo y te la enviaremos vía WhatsApp
              </Typography>
            </Box>

            <Box sx={{ mt: 2, mb: 1 }}>
              <Button variant="default" onClick={logOut} sx={{ minWidth: "125px" }}>
                Salir
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default WaitingRoomAvalAdicional;
